/// <reference path="../../apps/typings/customTds.d.ts" />

 
export namespace Ajax {

	export function fragment(options: JQuery.AjaxSettings,
		callback?: (data?: any, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback?: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void,
		timeout?: number): JQueryXHR {
		return T.Utils.Ajax.fragment(options, callback, errorCallback, timeout);
	}
	export function beforeSend(jqXHR: JQueryXHR, settings: JQuery.AjaxSettings): void {
		(jqXHR as JQueryXHR & { url?: string }).url = settings.url;
	}
}
